export default __webpack_public_path__ + "static/media/MedhaviBasera_webdev - 781_Medhavi Basera.78e53ca5.jpg";